import React, { useState } from "react";
import cx from "clsx";
import { getUserPaymentSystem } from "../../../../../../../utilities/localStorage";
import { Button } from "../../../../../../../shared/Button/Button";
import styles from "../scss/AdditionalClinicSurges.module.scss";
import { Table } from "../../../../../../../shared/Table/Table";
import { DeleteIcon } from "../../../../../../../assets/Icons/DeleteIcon";
import { EditIcon } from "../../../../../../../assets/Icons/EditIcon";
import {
  applicationLevelOptions,
  exclusionsOptions,
  rulesOptions,
  taxTypeOptions,
} from "../AdditionalClinicSurgesModal.utils";
import CreateClinicAdditionalSurgesModal from "./CreateClinicAdditionalSurgesModal";
import CreateClinicAdditionalSurgesDelete from "./CreateClinicAdditionalSurgesDelete";
import { useCurrentAccountQuery } from "../../../../../../../api/queries/useAccountQuery";

const CreateClinicAdditionalSurges = ({
  additionalTaxes,
  setAdditionalTaxes,
}) => {
  const [modal, setModal] = useState({ show: false, data: null });
  const [deleteModal, setDeleteModal] = useState({ show: false, id: null });

  const { data: accountData } = useCurrentAccountQuery();
  const isClearent = getUserPaymentSystem() === "clearent";
  const isStripe = getUserPaymentSystem() === "stripe";
  const showStripeWarning = isStripe && !accountData?.globalSettings?.isSurchargeEnabled;

  const tableData = additionalTaxes?.map((item, index) => {
    const applicationLevel = applicationLevelOptions.find(
      (option) => option.value === item.level,
    );

    const taxType = taxTypeOptions.find(
      (option) => option.value === item.tax_type,
    );

    const rules = rulesOptions.find((option) => option.value === item.type);

    const exclusions = exclusionsOptions
      .filter((option) => item.exclusions.includes(option.value))
      .map((option) => option.label);

    return {
      name: item.label,
      percentage: item.percentage,
      applicationLevel: applicationLevel.label,
      taxType: taxType.label,
      cascading: item.cascading ? "Yes" : "No",
      exclusions: exclusions.join(", ") || "None",
      rules: rules.label,
      action: (
        <div className={styles.actionCol}>
          <button
            className={cx(styles.actionBtn, styles.edit)}
            onClick={() =>
              setModal({ show: true, data: { ...item, id: index } })
            }
          >
            {" "}
            <EditIcon width="15px" />
          </button>
          <button
            className={cx(styles.actionBtn, styles.delete)}
            onClick={() => setDeleteModal({ show: true, id: index })}
          >
            <DeleteIcon width="15px" />
          </button>
        </div>
      ),
    };
  });

  return (
    <>
      <div className={styles.container}>
        <Button
          variant="text"
          rightAdornment={<div className={styles.plusIcon}>+</div>}
          onClick={() => setModal({ show: true, data: null })}
          className={styles.additionalSurchargesBtn}
        >
          Additional Clinic Surcharges
        </Button>
        {additionalTaxes.length > 0 && (
          <Table
            className={styles.surchargesTable}
            cols={[
              { data: "Name", accessor: "name" },
              { data: "Percentage", accessor: "percentage" },
              { data: "Application Level", accessor: "applicationLevel" },
              { data: "Tax Type", accessor: "taxType" },
              { data: "Cascading", accessor: "cascading" },
              { data: "Rules", accessor: "rules" },
              { data: "Exclusions", accessor: "exclusions" },
              { data: "Action", accessor: "action" },
            ]}
            data={tableData}
          />
        )}
      </div>
      {modal.show && (
        <CreateClinicAdditionalSurgesModal
          modal={modal}
          setModal={setModal}
          additionalTaxes={additionalTaxes}
          setAdditionalTaxes={setAdditionalTaxes}
          isClearent={isClearent}
          showStripeWarning={showStripeWarning}
        />
      )}
      {deleteModal.show && (
        <CreateClinicAdditionalSurgesDelete
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          additionalTaxes={additionalTaxes}
          setAdditionalTaxes={setAdditionalTaxes}
        />
      )}
    </>
  );
};

export default CreateClinicAdditionalSurges;
